<!-- IMPORTANT! - For concistency please use the following structure for future development -->
<!-- <div class="user-settings-tab-panel-wrapper">
    <div class="user-settings-control-row" fxLayout="row">
        <div class="row-content" fxflex="80%" fxlayout="column">
            <span [ngClass]="{'disabled': className}" class="user-settings-control-row_title">Setting Title</span>
            <p class="user-settings-control-row_description">Setting Description</p>
        </div>
        <div class="setting_toggle" fxflex="20%" fxlayout="row" fxlayoutalign="center">
            <bfx-toggle></bfx-toggle>
        </div>
    </div>
</div> -->

<div class="user-settings-component-container" fxLayout="column">
  <div class="user-settings-control-row">
    <div class="row-content" fxflex="80%" fxlayout="column">
      <span class="user-settings-control-row_title" [ngClass]="{'disabled': !multiplyAmount.toggle}"
        >Multiply Amounts by 1 Million</span
      >
      <p class="user-settings-control-row_description">
        Amounts entered below the specified amount will be automatically multiplied by 1 million
      </p>
    </div>

    <div class="row-content multiplyAmount" fxFlex="20%">
      <number-spinner
        size="sm"
        min="0"
        max="9999"
        [disabled]="multiplyAmount.valueDisable"
        [step]="multiplyAmount.step"
        [(ngModel)]="multiplyAmount.value"
        (blur)="multiplyAmountValueBlur($event)"
        (spinnerBtnClick)="multiplyAmountValueBlur($event)"
      >
      </number-spinner>
    </div>
    <div
      class="setting_toggle multiplyAmountToggle"
      fxFlex="10%"
      fxLayout="row"
      style="max-width: 72px"
    >
      <bfx-toggle
        [(ngModel)]="multiplyAmount.toggle"
        (change)="multiplyAmountToggleChanged($event)"
      >
      </bfx-toggle>
    </div>
  </div>
  <div class="user-settings-control-row" fxLayout="row">
    <div class="row-content" fxflex="80%" fxlayout="column">
      <span class="user-settings-control-row_title">New Order Button Default</span>
      <p class="user-settings-control-row_description">
        Sets the type of New Order Ticket that will open when the New Order button is clicked.
      </p>
    </div>
    <div class="row-content newOrderTypeDefault" fxFlex="30%" fxLayout="column">
      <div class="user-settings-control right">
        <bfx-autoComplete
          #newOrderTypeDefaultSelection
          appendTo="body"
          size="sm"
          [(ngModel)]="newOrderTypeDefault"
          [suggestions]="newOrderTypeDefaultSuggestions"
          (completeMethod)="searchNewOrderTypeDefault($event)"
          [dropdown]="true"
          (onBlur)="onBlurAutocomplete(newOrderTypeDefaultSelection)"
          (onSelect)="onSelectNewOrderTypeDefault($event)"
          (onFocus)="$event.target.select()"
          field="label"
          dataKey="value"
          [maxlength]="50"
          [allowEmptySelection]="false"
          [settingsCorrection]="true"
          [skipSorting]="true"
        ></bfx-autoComplete>
      </div>
    </div>
  </div>
</div>
